import { media, styled } from '@styles';

import { Button } from '@components/atoms/Button';

export const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 60px 40px;
  margin-top: 40px;
  ${media.largeScreen`
    grid-gap: 40px 26px;
    margin-top: 30px;
  `}
  ${media.smMediumScreen`
    grid-template-columns: 1fr 1fr;
  `}
  ${media.smallScreen`
    grid-template-columns: 1fr;
    grid-gap: 16px;
  `}
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const ShowMoreButton = styled(Button)`
  &.showmore {
    width: 320px;
    height: 68px;
    font-size: ${(props) => props.theme.typography.smallFontSize};
    margin: auto;
    margin-bottom: 32px;
    grid-column-start: 2;
    grid-column-end: 2;
    ${media.largeScreen`
      width: 200px;
      height: 48px;
    `}
    ${media.smMediumScreen`
      grid-column-start: 1;
      grid-column-end: none;
    `}
  }
`;

export const BorderDiv = styled.div`
  width: 100%;
  border-bottom: 1px solid #cccccc;
  margin: 100px 0 40px;
  ${media.largeScreen`
    margin: 80px 0 30px;
  `}
  ${media.smMediumScreen`
    margin: 70px 0 30px;
  `}
  ${media.smallScreen`
    margin: 40px 0 30px;
  `}
`;
